export default {
	custom: {
		email: {
			required: "L'email és obligatori",
			email: "Has de proporcionar una adreça de correu electrònic vàlida"
		},
		telefono: {
			required: "El camp telèfon és obligatori",
			length: "El camp telèfon no és correcte"
		},
		nombre: {
			required: "El camp nom és obligatori"
		},
		mensaje: {
			required: "El camp missatge és obligatori"
		},
		apellidos: {
			required: "El camp cognoms és obligatori"
		},
		politica: {
			required: "Has d'acceptar la política de privacitat"
		},
		comunicaciones: {
			required: "Has d'acceptar l'enviament de comunicacions"
		},
		empresa: {
			required: "El camp empresa és obligatori"
		},
		direccion: {
			required: "El camp adreça és obligatori"
		},
		pais: {
			required: "El camp país és obligatori"
		},
		carta_presentacion: {
			required: "El camp carta de presentació és obligatori"
		},
		doc_adjunto: {
			size: "La mida màxima és de 2MB",
			mimes: "El format ha de ser PDF"
		}
	}
}



// WEBPACK FOOTER //
// ./src/validator/ca.js